import Router from 'next/router';
import React, { useEffect } from 'react';

function usePreventExit(
  form,
  ignoreUrls = [],
  confirmationText = 'You may lose unsaved changes if you leave this page.'
) {
  useEffect(() => {
    const onUnload = e => {
      // the method that will be used for both add and remove event
      // eslint-disable-next-line no-param-reassign
      const _e = e || window.event;
      const confirmationMessage = confirmationText;
      _e.returnValue = confirmationMessage;
      return confirmationMessage;
    };

    const handleExit = url => {
      const touched = form.isFieldsTouched();

      const shouldIgnore = ignoreUrls.some(urlToIgnore => {
        return urlToIgnore === url;
      });

      if (
        touched &&
        Router.pathname !== url &&
        !shouldIgnore &&
        !window.confirm('You may lose unsaved changes if you leave this page')
      ) {
        Router.events.emit('routeChangeError');
        // eslint-disable-next-line no-throw-literal
        throw 'Abort route change.';
      }
    };

    Router.events.on('routeChangeStart', handleExit);
    window.addEventListener('beforeunload', onUnload);

    return () => {
      Router.events.off('routeChangeStart', handleExit);
      window.removeEventListener('beforeunload', onUnload);
    };
  }, []);
}

export default usePreventExit;
